export default "__VITE_ASSET__BqVwytB6__"